<template>
    <!-- Header -->
    <header id="header" data-transparent="true" data-responsive-fixed="true" class="submenu-light">
        <div class="header-inner">
            <div class="container">
                <!--Logo-->
                <div id="logo">
                    <router-link to="/">
                        <span class="logo-default"><img :src="logo"></span>
                        <span class="logo-dark"><img :src="logo"></span>
                    </router-link>
                </div>
                <!--End: Logo-->
                
                <!--Header Extras-->
                <div class="header-extras">
                    <ul>
                        <li>
                            <router-link to="/productos">Productos</router-link>
                        </li>
                        <li v-if="$route.path == '/productos' || $route.path.includes('/detalle-producto') || $route.path == '/carrito' || $route.path == '/checkout' || $route.path == '/compras'">
                            <div class="p-dropdown">
                                <a href="#"><i class="icon-shopping-cart"></i> ( {{ $store.state.carrito.productos.length }} )</a>
                                <ul class="p-dropdown-content">
                                    <li><router-link to="/carrito"><i class="icon-shopping-cart"></i> Ver carrito ( {{ $store.state.carrito.productos.length }} )</router-link></li>
                                </ul>
                            </div>
                        </li>
                        <li v-if="$store.getters.usuario">
                            <router-link to="/compras">Compras</router-link>
                        </li>
                        <li v-if="$route.path == '/productos' || $route.path.includes('/detalle-producto') || $route.path == '/carrito' || $route.path == '/checkout' || $route.path == '/compras'">
                            <div class="p-dropdown" v-if="$store.getters.usuario">
                                <a href="#"><i class="icon-user"></i> {{ $store.getters.usuario.nombre }} {{ $store.getters.usuario.apellidos }}</a>
                                <ul class="p-dropdown-content">
                                    <li><router-link to="/login?logout=1"><i class="icon-log-out"></i> Cerrar sesión</router-link></li>
                                </ul>
                            </div>
                        </li>
                        <li v-if="!$store.getters.usuario">
                            <router-link to="/login">Ingresar</router-link>
                        </li>
                        <li>
                            <div>
                                <a :href="sitioPro"><i class="icon-log-in"></i></a>
                            </div>
                        </li>
                    </ul>
                </div>
                <!--end: Header Extras-->
                <!--Navigation Resposnive Trigger-->
                <div id="mainMenu-trigger">
                    <a class="lines-button x"><span class="lines"></span></a>
                </div>
                <!--end: Navigation Resposnive Trigger-->
                <!--Navigation-->
                <div id="mainMenu" class="menu-one-page">
                    <div class="container">
                        <nav v-if="$route.path == '/'">
                            <ul>
                                <li v-if="hostname != 'innovaccion.etciberoamerica.com'"><router-link to="/">Inicio</router-link></li>
                            </ul>
                        </nav>
                        <nav v-if="$route.path == '/productos'">
                            <ul>
                                <li><router-link to="/">Inicio</router-link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <!--end: Navigation-->
            </div>
        </div>
    </header>
</template>

<script>
/* eslint-disable */
export default {
    name: 'HeaderComponent',
    components: {

    },
    data() {
        return {
            sitioPro: 'https://pro.etciberoamerica.com',
            hostname: '',
            logo: '/images/logo-etc.png'
        }
    },

    async mounted() {
        this.hostname = hostname
        if(localStorage.tokenETCSistema) {
            await this.getUserApi()
            this.$store.commit('setUsuario', user)
            await this.getProductosCarrito()
            this.$parent.productos = this.$store.getters.productos
        }

        if(this.hostname == 'store.etciberoamerica.com' || this.hostname == 'innovaccion.etciberoamerica.com') {
            this.sitioPro = 'https://pro.etciberoamerica.com'
            if(this.hostname == 'innovaccion.etciberoamerica.com')
                this.logo = '/images/eThinking-pro-sm.png'
        }

        if(this.hostname == 'storebpo.etciberoamerica.com') {
            this.sitioPro = 'https://bpo.etciberoamerica.com'
            this.logo = '/images/bpo-login-logo.png'
        }

        if(this.hostname == 'store-conalepon.etciberoamerica.com') {
            this.sitioPro = 'https://store-conalepon.etciberoamerica.com'
            this.logo = '/images/conalep-logo.png'
        }        

        if(!this.$store.getters.usuario && (this.$route.path == '/checkout' || this.$route.path == '/compras')){
            router.replace('/login')
        }
    },

    beforeCreate() {
        if(!user) {
            if(!headers) {
                if(localStorage.tokenETCSistema) {
                    headers = {
                        'Content-Type': 'application/json',
                        Authorization: localStorage.tokenETCSistema
                    }
                }
            }
        }
    },
}
</script>
